import { httpApi } from '@app/api/http.api';
import {
  Page,
  CreatePageDto,
  UpdatePageDto,
  PagePaginatedResponse,
  PageFilters,
} from '@app/types/api.types';

export const createPage = (data: CreatePageDto): Promise<Page> =>
  httpApi.post<Page>('/pages', data).then(({ data }) => data);

export const getPages = (filters?: PageFilters): Promise<PagePaginatedResponse> =>
  httpApi
    .get<PagePaginatedResponse>('/pages', { params: filters })
    .then(({ data }) => data);

export const getPublishedPages = (params?: { page?: number; limit?: number }): Promise<PagePaginatedResponse> =>
  httpApi
    .get<PagePaginatedResponse>('/pages/published', { params })
    .then(({ data }) => data);

export const getPageBySlug = (slug: string): Promise<Page> =>
  httpApi.get<Page>(`/pages/slug/${slug}`).then(({ data }) => data);

export const getPageById = (id: string): Promise<Page> =>
  httpApi.get<Page>(`/pages/${id}`).then(({ data }) => data);

export const updatePage = (id: string, data: UpdatePageDto): Promise<Page> =>
  httpApi.patch<Page>(`/pages/${id}`, data).then(({ data }) => data);

export const deletePage = (id: string): Promise<void> =>
  httpApi.delete<void>(`/pages/${id}`).then(() => undefined);

